import { useNavigate } from "@tanstack/react-router";
import { useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { useSession } from "@/stores/session";
import { endpoints } from "@/lib/endpoints";

/**
 * Signs out locally whatever the server says. A failed call still clears the
 * session and the cache: a device left on a desk must not keep showing a
 * previous host's bookings because the network was down.
 */
export function useSignOut() {
  const navigate = useNavigate();
  const qc = useQueryClient();
  return async () => {
    try {
      await api(endpoints.auth.signOut, { method: "POST", quiet401: true });
    } finally {
      useSession.getState().restore();
      qc.clear();
      void navigate({ to: "/sign-in" });
    }
  };
}
